import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  appInitiaLizeInfo: any | undefined
  constructor() {}
  set AppInitializeInfo(appInitiaLizeInfo: any | undefined) {
    this.appInitiaLizeInfo = appInitiaLizeInfo
  }
  get AppInitializeInfo() {
    return this.appInitiaLizeInfo
  }
}
